import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { NominalPaymentsComponent } from '@app/components/apps/NominalPayments/NominalPaymentsComponent';

export const ViewNominalPayment: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('View Nominal Payment Task');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    { path: '/nominal-payments', breadcrumbName: 'Nominal Payments' },
    { path: '/view-nominal-payment', breadcrumbName: currentBreadcrumName },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <NominalPaymentsComponent
          type={'view'}
          editable={false}
          id={id}
          pageTitle={`View Nominal Payment Task`}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default ViewNominalPayment;
